import { DataGridContextProvider } from '@cmg/data-grid';
import {
  Divider,
  IconButton,
  InfoOutlinedIcon,
  PageHeader,
  PageLayout,
  Stack,
  SvgIcon,
  Tooltip,
  Typography,
} from '@cmg/design-system';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import ScreenHeader from '../../shared/layout/ScreenHeader';
import { ParticipationReportDataGrid } from './components';

type Props = RouteComponentProps;

export const InvestorParticipationReportRoute: React.FC<Props> = () => {
  return (
    <DataGridContextProvider>
      <Stack flex={1} style={{ height: '100%' }}>
        <ScreenHeader />
        <PageLayout
          flex={1}
          header={
            <React.Fragment>
              <Divider />
              <PageHeader
                pageTitle={
                  <React.Fragment>
                    Investor Participation{' '}
                    <Tooltip
                      placement="right"
                      variant="info"
                      title={
                        <Stack maxWidth={theme => theme.spacing(59.75)}>
                          <Typography variant="tooltip" fontWeight="bold">
                            Offerings containing your private investor data
                          </Typography>
                          <Typography variant="tooltip">
                            To upload data, navigate to an offering profile and click ‘Upload
                            Participation Data’. Once the data is uploaded, the offering will be
                            available for selection and analysis.
                          </Typography>
                        </Stack>
                      }
                    >
                      <IconButton>
                        <SvgIcon component={InfoOutlinedIcon} fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </React.Fragment>
                }
                actions={
                  [
                    // TODO - when adding export functionality, uncomment the following lines
                    // <Button key="download" startIcon={<FileDownloadOutlinedIcon />} disabled>
                    //   Export
                    // </Button>,
                  ]
                }
              />
              <Divider />
            </React.Fragment>
          }
        >
          <ParticipationReportDataGrid />
        </PageLayout>
      </Stack>
    </DataGridContextProvider>
  );
};
